import { BookOpen, BookX, MessageCircle, FileText } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import type { Engagement } from './types';

type Props = {
  engagement: Engagement;
};

export function EngagementMetrics({ engagement }: Props) {
  const items = [
    { label: 'Diari completati', value: engagement.diaries_completed, icon: BookOpen, warn: false },
    { label: 'Diari incompleti', value: engagement.diaries_incomplete, icon: BookX, warn: engagement.diaries_incomplete > 0 },
    { label: 'Chat', value: engagement.chats_count, icon: MessageCircle, warn: false },
    { label: 'Note cliniche', value: engagement.notes_count, icon: FileText, warn: false },
  ];

  return (
    <Card variant="flat">
      <CardContent className="py-4">
        <div className="flex flex-col gap-3">
          {items.map((item) => {
            const Icon = item.icon;
            return (
              <div key={item.label} className="flex items-center gap-3">
                <Icon className={`size-4 shrink-0 ${item.warn ? 'text-amber-600 dark:text-amber-400' : 'text-muted-foreground'}`} />
                <span className={`text-2xl font-semibold tabular-nums ${item.warn ? 'text-amber-600 dark:text-amber-400' : ''}`}>
                  {item.value}
                </span>
                <span className="text-muted-foreground text-xs">{item.label}</span>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
